import { useTranslation } from 'react-i18next'

type WelcomeCardProps = {
  firstName?: string
}

const WelcomeCard = ({ firstName }: WelcomeCardProps) => {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-col items-center pt-6 pb-4">
      <img src="/icons/phone.svg" className="w-40 h-auto" alt="right chevron" />
      <h2 className="text-white text-title-m text-center pt-6">
        {t('global.hello')} {firstName},
      </h2>
      <p className="text-white text-l text-center">{t('pages.home.evaluate-message')}</p>
    </div>
  )
}

export default WelcomeCard
